const options = {
  hours: 24,
  minutes: 60,
  seconds: 60,
  millisec: 1000,
};
const MILLISECONDS_IN_DAY = options.hours * options.minutes * options.seconds * options.millisec;

export function setCookie(name, value, days) {
  let expires = '';
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * MILLISECONDS_IN_DAY);
    expires = `; expires=${date.toUTCString()}`;
  }
  document.cookie = `${name}=${(value || '') + expires}; path=/`;
}

export function getCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export function eraseCookie(name) {
  document.cookie = `${name}=; Max-Age=-99999999;`;
}
